import app from 'flarum/forum/app';
import categorySelect from './categorySelect';
import chooseCategoryOnNewDiscussion from './chooseCategoryOnNewDiscussion';
import addForumsMenu from './addForumsMenu';
import removeSidebarNav from './removeSidebarNav';
import redesignTagsPage from './redesignTagsPage';
import redesignIndexPage from './redesignIndexPage';
import simplifyDiscussionListItem from './simplifyDiscussionListItem';
import restrictSidebarWidgetsToIndexPages from './restrictSidebarWidgetsToIndexPages';
import placeDropdownMenus from './placeDropdownMenus';
import fitHeaderMenusToViewport from './fitHeaderMenusToViewport';
import removeMarkdownComposerButtons from './removeMarkdownComposerButtons';
import removeRichTextToolbarButtons from './removeRichTextToolbarButtons';
import removeTitleSort from './removeTitleSort';
import addUnansweredSort from './addUnansweredSort';
import showTagRulesInComposer from './showTagRulesInComposer';
import showHighestGroupBadgeOnly from './showHighestGroupBadgeOnly';
import showPostImagesInLightbox from './showPostImagesInLightbox';
import shareTagListRequests from './shareTagListRequests';
import showEditNextToReply from './showEditNextToReply';
import showPostDateTime from './showPostDateTime';
import showOldDiscussionTitle from './showOldDiscussionTitle';
import showFrenchEmojiNames from './showFrenchEmojiNames';
import openEmojiListAfterLetter from './openEmojiListAfterLetter';
import keepRenamedTitleUnselected from './keepRenamedTitleUnselected';
import fixMediaManagerDisplayNameModal from './fixMediaManagerDisplayNameModal';
import followNonRouteInternalLinks from './followNonRouteInternalLinks';
import retryOnStaleCsrfToken from './retryOnStaleCsrfToken';
import retryFailedReads from './retryFailedReads';
import showErrorAlertOnce from './showErrorAlertOnce';
import focusComposerOnTouch from './focusComposerOnTouch';
import labelPostAvatarLinks from './labelPostAvatarLinks';
import addTextColorButton from './addTextColorButton';
import addUnderlineButton from './addUnderlineButton';
import addPostPreview from './addPostPreview';
import allowTouchScrollInModals from './allowTouchScrollInModals';
// Not used here: bundled (and so registered in flarum.reg) for the other
// champis extensions' pages that start a discussion in one category, and
// those that show a discussion's text as their own.
import './utils/startDiscussion';
import './utils/editPost';
import './components/EditPostButton';
app.initializers.add('champis-forum', () => {
  shareTagListRequests();
  categorySelect();
  chooseCategoryOnNewDiscussion();
  addForumsMenu();
  removeSidebarNav();
  redesignTagsPage();
  redesignIndexPage();
  simplifyDiscussionListItem();
  placeDropdownMenus();
  fitHeaderMenusToViewport();
  removeMarkdownComposerButtons();
  removeRichTextToolbarButtons();
  removeTitleSort();
  addUnansweredSort();
  showTagRulesInComposer();
  showHighestGroupBadgeOnly();
  showPostImagesInLightbox();
  showEditNextToReply();
  showPostDateTime();
  showOldDiscussionTitle();
  showFrenchEmojiNames();
  openEmojiListAfterLetter();
  keepRenamedTitleUnselected();
  fixMediaManagerDisplayNameModal();
  followNonRouteInternalLinks();
  retryOnStaleCsrfToken();
  retryFailedReads();
  showErrorAlertOnce();
  focusComposerOnTouch();
  labelPostAvatarLinks();
  addTextColorButton();
  addUnderlineButton();
  addPostPreview();
  allowTouchScrollInModals();
  // Last: its IndexSidebar.items() extend() must run after every add()
  // above, champis-species', and champis-events' addHomeEvents() has had a
  // chance to register the items it then removes - extend() callbacks for
  // the same hook fire in registration order, and champis-forum is the
  // last extension enabled (champis-events loads right before it - see
  // extensions_enabled in settings).
  restrictSidebarWidgetsToIndexPages();
});